import { Property } from "@/Models/Eav";
import { Button } from "@/components/ui/button";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { Separator } from "@/components/ui/separator";
import clsx from "clsx";
import { ChevronRight } from "lucide-react";
import PropertyRow from "./PropertyRow";

interface PropertyGroupProps {
    group: Property;
    debouncedSearch: string;
    isOpen: boolean;
    onToggle: () => void;
    openProps: string[];
    toggleProp: (name: string) => void;
}

const PropertyGroup = ({ group, debouncedSearch, isOpen, onToggle, openProps, toggleProp }: PropertyGroupProps) => (
    <div key={group.category}>
        <Collapsible open={isOpen} onOpenChange={onToggle}>
            <CollapsibleTrigger asChild>
                <Button
                    variant="ghost"
                    className="flex w-full justify-between rounded-none px-4 py-6 text-md font-semibold hover:bg-muted"
                >
                    <span>{group.category}</span>
                    <ChevronRight
                        className={clsx("h-5 w-5 shrink-0 transition-transform duration-200", isOpen && "rotate-90")}
                    />
                </Button>
            </CollapsibleTrigger>
            <CollapsibleContent>
                <Separator />
                {group.values.map((prop, pIdx) => {
                    const propKey = `${group.category}-${prop.attr.Name}`;
                    return (
                        <PropertyRow
                            key={propKey}
                            group={group}
                            prop={prop}
                            pIdx={pIdx}
                            debouncedSearch={debouncedSearch}
                            isOpen={openProps.includes(propKey)}
                            onToggle={() => toggleProp(propKey)}
                        />
                    );
                })}
            </CollapsibleContent>
        </Collapsible>
    </div>
);

export default PropertyGroup;
